import React from 'react';
import { Tag, seg } from '../../../../tags/Tag';

export interface DropdownFooterAction {
  label: string;
  onClick: () => void;
  disabled?: boolean;
}

export interface DropdownFooterProps {
  actions: DropdownFooterAction[];
  singleAction?: boolean;
  /** @deprecated No longer needed -- border always uses glass tokens */
  variant?: 'subtle' | 'default' | 'strong' | 'glassmorphic';
  className?: string;
}

const cx = (...classes: (string | boolean | undefined)[]) =>
  classes.filter(Boolean).join(' ');

export function DropdownFooter({
  actions,
  singleAction = false,
  className
}: DropdownFooterProps) {
  const footerClasses = cx(
    'core-dropdown-footer',
    singleAction && 'core-dropdown-footer--single',
    className
  );

  return (
    <div className={footerClasses}>
      {actions.map((action, index) => (
        <Tag
          key={index}
          template="action-sm"
          segments={[seg.text(action.label, { size: 'md' })]}
          onClick={action.onClick}
          disabled={action.disabled}
        />
      ))}
    </div>
  );
}
